module.exports = (s) => {
  return [
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '跳转类型',
      format: (row) => {
        const h = s.$createElement;
        const ele = h(
          'el-select',
          {
            props: {
              size: 'mini',
              value: row.type.value,
              placeholder: '请选择',
            },
            on: {
              change: (type) => {
                row.type.value = type;
                s?.getTargetConfig(type, row);
              },
            },
          },
          row.type.options.map(({ label, value }) => {
            return h('el-option', { props: { label, value }}, null);
          })
        );

        return ele;
      },
    },
    {
      name: '跳转目标',
      width: '300px',
      format: (row) => {
        const h = s.$createElement;
        const type = row.type.value;

        return type ? h('div', {}, [
          h(
            'el-select',
            {
              class: 'mr-10',
              props: {
                size: 'mini',
                value: row.target[type].value,
                placeholder: '请选择',
              },
              on: {
                change: (value) => {
                  row.target[type].value = value;
                },
              },
            },
            row.target[type].options.map(({ label, value }) => {
              return h('el-option', { props: { label, value }}, null);
            })
          ),
          h(
            'el-button',
            {
              props: {
                size: 'mini',
                type: 'primary',
              },
              on: {
                click: () => {
                  s?.addBrand(row.advertiser_id);
                },
              },
            },
            '新增'
          ),
        ]) : '-';
      },
    },
  ];
};
